import { jsxs as y, jsx as d } from "react/jsx-runtime";
import { u as i } from "./index-6a632112.mjs";
import { r as R, c as z, s as m, f as v, a as E, e as L, l as H } from "./themes-5f0b3c3d.mjs";
import { l as P } from "./lineHeights-72d3110c.mjs";
import G, { useRef as U, useState as j, useEffect as B } from "react";
import { useAccessibilityProps as N } from "./accessibility.js";
import { u as A } from "./uniqueId-321287e8.mjs";
import { L as q } from "./label-3b996c7d.mjs";
import { H as K } from "./helperText-698f3ed9.mjs";
import "./tooltip.js";
import "./useWindowDimensions.js";
import "./zIndices-d07533f3.mjs";
import "./getElementPosition-5026bb28.mjs";
import "./popupTip.js";
import "./closeButton.js";
import "./cancelClose-87fdf326.mjs";
import "./types-b577bf77.mjs";
import "./iconButton.js";
import "./button.js";
import "./textStyles-42cab346.mjs";
import "./fontWeights-a25f8f91.mjs";
import "./checkmarkFilled-c2b01ef1.mjs";
import "./informationFilled-05d57719.mjs";
import "./warningFilled-691cfde1.mjs";
const V = i.label`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;

  &&:focus-visible:not([disabled]) {
    outline-style: solid;
    outline-color: ${(e) => e.theme.components.radio.focusColor};
    outline-width: 2px;
    border-radius: ${R["2x"]};
    outline-offset: 2px;
  }
`, X = i.div``, J = i.input`
  margin: unset;
  position: relative;
  top: 2px;
  appearance: none;
  height: 20px;
  width: 20px;
  border-radius: ${R["3x"]};
  box-sizing: border-box;
  border: 1px solid
    ${(e) => e.disabled ? e.theme.components.radio.borderColorDisabled : e.$error ? e.theme.components.radio.errorColor : e.theme.components.radio.borderColor};
  background-color: ${(e) => e.disabled ? e.theme.components.radio.backgroundColorDisabled : e.theme.components.radio.backgroundColor};
  display: inline-flex;
  justify-content: center;
  align-items: center;
  flex: none;
  transition: border 120ms ease-in;

  &:hover {
    cursor: ${(e) => e.disabled ? "default" : "pointer"};
  }

  &:active {
    &:disabled {
      border: 2px solid
        ${(e) => e.theme.components.radio.disabledClickColor};
      background-color: ${(e) => e.theme.components.radio.disabledClickBackgroundColor};

      &:checked {
        border: 8px solid
          ${(e) => e.theme.components.radio.disabledClickColor};
      }
    }
  }

  &:not(:active) {
    &:disabled {
      transition: border 0.25s, background-color 0.25s;
      transition-timing-function: ease-in;
    }
  }

  &:hover:not([disabled]) {
    border: 2px solid
      ${(e) => e.$error ? e.theme.components.radio.errorHoverColor : e.theme.components.radio.hoverColor};
  }

  &:checked {
    background-color: ${(e) => e.disabled && e.checked ? e.theme.components.radio.backgroundColorDisabled : e.$error ? z.brandTwilight[0] : e.theme.components.radio.checkedBackgroundColor};
    border: 8px solid
      ${(e) => e.disabled && e.checked ? e.theme.components.radio.borderColorDisabled : e.disabled ? e.theme.components.radio.borderColor : e.$error ? e.theme.components.radio.errorColor : e.theme.components.radio.fillColor};
    &:hover:not([disabled]) {
      border: 8px solid
        ${(e) => e.$error ? e.theme.components.radio.errorHoverColor : e.theme.components.radio.hoverActiveColor};
    }
  }
`, M = i.label`
  ${(e) => e && `
      padding-right: ${m["4x"]};
      max-width: 300px;
    `}
  color: ${(e) => e.disabled ? e.theme.components.radio.textColorDisabled : e.theme.components.radio.textColor};
  font-family: ${v.inter};
  font-size: ${E.small};
  font-style: normal;
  font-weight: ${L.regular.L.fontWeight};
  line-height: ${P.medium};
  width: 100%;
  &:hover {
    cursor: ${(e) => e.disabled ? "default" : "pointer"};
  }

  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;

  -o-user-select: none;
  user-select: none;
`, Q = i.span`
  color: ${(e) => e.disabled ? e.theme.components.radio.textColorDisabled : e.theme.components.radio.textColor};
  font-family: ${v.inter};
  font-size: ${E.xsmall};
  letter-spacing: ${H[0]};
  line-height: ${P.small};
  margin: 0px 0px ${m["2x"]} 0px;
  overflow-wrap: break-word;
  display: block;
`, Y = "RADIO_DATA_TEST_ID", Z = "RADIO_WRAPPER_DATA_TEST_ID", Re = ({
  checked: e = void 0,
  label: n,
  error: a = !1,
  helperText: p,
  horizontal: C = !0,
  disabled: t,
  id: u = "FDSRadioComponent",
  key: f,
  onChange: D,
  onClick: _,
  value: s,
  className: l,
  dataTestId: h = Y,
  accessibilityOptions: b = {
    ariaDisabled: t,
    ariaChecked: e,
    ariaLabel: typeof n == "string" && n || void 0
  },
  tabIndex: $
}) => {
  const g = N("radio", {
    ...b
  });
  return /* @__PURE__ */ y(
    V,
    {
      className: l,
      "data-testid": Z,
      children: [
        /* @__PURE__ */ d(X, { disabled: t, children: /* @__PURE__ */ d(
          J,
          {
            id: u,
            "data-testid": h,
            type: "radio",
            value: s,
            $error: a,
            checked: e,
            disabled: t,
            onChange: () => D?.(s),
            onClick: _,
            tabIndex: $ || (t ? -1 : 0),
            onKeyDown: (c) => {
              (c.code === "Enter" || c.code === " ") && _?.();
            },
            ...g
          }
        ) }),
        /* @__PURE__ */ y(M, { disabled: t, htmlFor: u, $horizontal: C, children: [
          n,
          p && /* @__PURE__ */ d(Q, { disabled: t, children: p })
        ] })
      ]
    },
    f
  );
}, ee = () => ` 
  border: 0 none !important;
  margin: unset !important;
  padding: 0 !important;
  margin-inline-start: 0;
  margin-inline-end: 0;
  padding-block-start: 0;
  padding-inline-start: 0;
  padding-inline-end: 0;
  padding-block-end: 0;`, oe = i.fieldset`
  ${ee()}
  display: flex;
  flex-direction: column;
  gap: ${m["3x"]};
  legend {
    margin-bottom: ${m["3x"]};
  }
`, re = i.div`
  flex-direction: ${({ $horizontal: e }) => e ? "none" : "column"};
  display: flex;
  gap: ${m["4x"]};
`, te = "RADIO_GROUP_DATA_TEST_ID", I = "RadioGroup", ve = ({
  children: e = [],
  horizontal: n = !1,
  value: a,
  onChange: p,
  error: C = !1,
  label: t,
  helperText: u,
  required: f = !1,
  className: D,
  helperTextClassName: _,
  dataTestId: s = te,
  isInvalid: l,
  helperTextProp: h = {
    [l ? "secondaryProp" : "defaultProp"]: {
      helperText: u,
      id: `${l ? "invalid" : "valid"}_${I}_helperText`,
      ...l && { state: "error" }
    }
  }
}) => {
  const b = U(A(I)), $ = `${b.current}_label_id`, g = Array.isArray(e) ? e : [e], c = () => {
    let o = -1;
    return a === null ? null : (a && (o = g.findIndex((r) => r?.props.value === a)), o > -1 ? o : -1);
  }, [x, k] = j(
    c()
  );
  B(() => {
    const o = c();
    o !== x && k(o);
  }, [a]);
  const S = A();
  return /* @__PURE__ */ y(
    oe,
    {
      "data-testid": s,
      className: D,
      $horizontal: n,
      children: [
        /* @__PURE__ */ d(
          q,
          {
            labelProp: {
              id: $,
              htmlFor: b.current,
              label: t,
              showRequiredIndicator: f
            },
            as: "legend"
          }
        ),
        /* @__PURE__ */ d(re, { $horizontal: n, children: g.map((o, r) => {
          if (!o)
            return null;
          const T = r + 1, w = o.props.disabled, O = x === r, F = o.props.error === !1 ? !1 : !!o.props.error || C;
          return G.cloneElement(o, {
            key: o.props.id || r,
            checked: O,
            disabled: w,
            required: f,
            onChange() {
              p?.(o.props.value);
            },
            onClick() {
              k(r);
            },
            onKeyUp(W) {
              W.key === "Enter" && k(r);
            },
            dataTestId: o.props.dataTestId ?? `${s}_RADIO_BUTTON_${T}`,
            id: o.props.id ?? `FDSRadioComponent${T}-${S}`,
            error: F,
            tabIndex: x === r || x === -1 && r === 0 ? 0 : -1
          });
        }) }),
        /* @__PURE__ */ d(
          K,
          {
            secondaryProp: h?.secondaryProp,
            defaultProp: h?.defaultProp
          }
        )
      ]
    }
  );
};
export {
  Re as Radio,
  ve as RadioList
};
